import { Text } from 'src/onboarding/components/typography/Text/Text';
import styles from './style.module.scss';
import { t } from '@web-solutions/module-localization';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { ReactComponent as LightningSvg } from '../../../../assets/images/lightning.svg';

import slimMen from '../../../../assets/images/slim-men.webp';
import midSizedMen from '../../../../assets/images/midsized-men.webp';
import plusSizedMen from '../../../../assets/images/plussized-men.webp';
import curvyMen from '../../../../assets/images/curvy-men.webp';

import slimWoman from '../../../../assets/images/slim.webp';
import midSizedWoman from '../../../../assets/images/midSized.webp';
import plusSizedWoman from '../../../../assets/images/plusSized.webp';
import curvyWoman from '../../../../assets/images/curvy.webp';

import { useStore } from 'src/onboarding/store/store';

const BODY_TYPE_ORDER = {
  female: ['slim', 'mid-sized', 'plus-sized', 'curvy'],
  male: ['slim', 'mid-sized', 'plus-sized', 'curvy'],
};

const maleBodyTypes = {
  slim: 'slim-male',
  'mid-sized': 'mid-sized-male',
  'plus-sized': 'plus-sized-male',
  curvy: 'curvy-male',
};

const femaleBodyTypes = {
  slim: 'slim-female',
  'mid-sized': 'mid-sized-female',
  'plus-sized': 'plus-sized-female',
  curvy: 'curvy-female',
};

const bodyTypeImages = {
  'slim-male': slimMen,
  'mid-sized-male': midSizedMen,
  'plus-sized-male': plusSizedMen,
  'curvy-male': curvyMen,
  'slim-female': slimWoman,
  'mid-sized-female': midSizedWoman,
  'plus-sized-female': plusSizedWoman,
  'curvy-female': curvyWoman,
};

const BeforeAfterCard = () => {
  const gender = useStore((state) => state.gender);
  const weight = useStore((state) => state.weight);
  const idealWeight = useStore((state) => state.idealWeight);
  const bodyType = useStore((state) => state.bodyType);

  const normalizedBodyType = bodyType.toLowerCase().replace(/\s+/g, '-');

  const isMale = gender === 'Male';
  const currentBodyTypeKey = isMale
    ? maleBodyTypes[normalizedBodyType]
    : femaleBodyTypes[normalizedBodyType];

  const currentBodyImage = bodyTypeImages[currentBodyTypeKey];

  const getSmallerBodyTypeKey = () => {
    const currentOrder = BODY_TYPE_ORDER[isMale ? 'male' : 'female'];
    const currentIndex = currentOrder.indexOf(normalizedBodyType);

    if (currentIndex <= 0) return currentBodyTypeKey;

    const smallerType = currentOrder[currentIndex - 1];
    return isMale ? maleBodyTypes[smallerType] : femaleBodyTypes[smallerType];
  };

  const smallerBodyTypeKey = getSmallerBodyTypeKey();
  const smallerBodyImage = bodyTypeImages[smallerBodyTypeKey];

  return (
    <div className={styles.beforeAfterContainer}>
      <div className={styles.weightCard}>
        <div className={`${styles.imageWrapper} ${styles.beforeImage}`}>
          <img src={currentBodyImage} alt='Current' />
          <Caption className={`${styles.label} ${styles.now}`}>
            {t('onboarding.beforeAfterCard.now')}
          </Caption>
        </div>
        <div className={styles.info}>
          <Caption size='s' className={styles.weightLabel}>
            {t('onboarding.beforeAfterCard.currentWeight')}
          </Caption>
          <Text size='s' semibold className={styles.weightValue}>
            {weight.type === 'lbs' ? `${weight.lbs} ${weight.type}` : `${weight.kg} ${weight.type}`}
          </Text>
          <div className={styles.nutritionBar}>
            <Caption size='s' className={styles.weightLabel}>
              {t('onboarding.beforeAfterCard.nutritionScore')}
            </Caption>
            <div className={styles.progress}>
              <span className={styles.progressGreen}></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.weightCard}>
        <div className={`${styles.imageWrapper} ${styles.afterImage}`}>
          <img src={smallerBodyImage} alt='Goal' />
          <Caption className={`${styles.label} ${styles.goal}`}>
            {t('onboarding.beforeAfterCard.yourGoal')}
          </Caption>
        </div>
        <div className={styles.info}>
          <Caption size='s' className={styles.weightLabel}>
            {t('onboarding.beforeAfterCard.goalWeight')}
          </Caption>
          <Text size='s' semibold className={styles.weightValue}>
            {`${idealWeight.value} ${idealWeight.type}`}
          </Text>
          <div className={styles.nutritionBar}>
            <Caption size='s' className={styles.weightLabel}>
              {t('onboarding.beforeAfterCard.nutritionScore')}
            </Caption>
            <div className={styles.progress}>
              <span className={styles.progressGreen}></span>
              <span className={styles.progressGreen}></span>
              <span className={styles.progressGreen}></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeforeAfterCard;
